import React from 'react';
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
} from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    padding: 32,
    fontSize: 12,
    lineHeight: 1.5,
  },

  heading1: {
    fontSize: 24,
    marginBottom: 12,
    fontWeight: 'bold',
  },

  heading2: {
    fontSize: 18,
    marginBottom: 10,
    marginTop: 16,
    fontWeight: 'bold',
  },

  paragraph: {
    marginBottom: 10,
  },

  listItem: {
    marginLeft: 12,
    marginBottom: 6,
  },

  code: {
    fontFamily: 'Courier',
    fontSize: 10,
    backgroundColor: '#eee',
    padding: 8,
    marginBottom: 10,
  },
});

type Props = {
  markdown: string;
};

function renderMarkdown(markdown: string) {
  const lines = markdown.split('\n');

  return lines.map((line, index) => {
    if (line.startsWith('# ')) {
      return (
        <Text key={index} style={styles.heading1}>
          {line.replace('# ', '')}
        </Text>
      );
    }

    if (line.startsWith('## ')) {
      return (
        <Text key={index} style={styles.heading2}>
          {line.replace('## ', '')}
        </Text>
      );
    }

    if (line.startsWith('- ')) {
      return (
        <Text key={index} style={styles.listItem}>
          • {line.replace('- ', '')}
        </Text>
      );
    }

    if (line.startsWith('```')) {
      return null;
    }

    return (
      <Text key={index} style={styles.paragraph}>
        {line}
      </Text>
    );
  });
}

export default function MarkdownPdf({ markdown }: Props) {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View>{renderMarkdown(markdown)}</View>
      </Page>
    </Document>
  );
}